import http from 'hub-http/clients/apiClient';
const defaultOptions = {
  timeout: [30000],
  retries: 2
};
export const getSubscriptionDefinitions = () => {
  return http.get('subscriptions/v1/definitions?includeInactive=true', Object.assign({}, defaultOptions));
};
export const getBrands = () => {
  return http.get(`/domains-brands/v1/brands`, defaultOptions);
};
export const getSubscriptionGroups = (includeInactive = false) => {
  return http.get('/subscriptions/v1/preferences-group/all/with-permissions', Object.assign({}, defaultOptions, {
    query: {
      includeInactive
    }
  }));
};
export const getProcessOptions = () => {
  return http.get('subscriptions/v1/definitions/processes-and-operations', defaultOptions);
};
export const getDataPrivacySettings = () => {
  return http.get('data-privacy-settings/hub-settings', defaultOptions);
};
export const getSubscriptionHistory = (recipient = null) => {
  return http.get(`subscriptions/v1/timeline/EMAIL/${recipient}/full-timeline`, Object.assign({}, defaultOptions));
};